module.exports = __webpack_public_path__ + "static/media/logo.49efa2af.svg";